import React from 'react';
import Icon from "./Icon";

export default ({className}) => {
    return (
        <div className={`active-flag position-absolute text-secondary ${className}`}>
            <Icon.Ring/>
        </div>
    )
}
